let _ = t => t,
    _t;

import styled, { css } from 'styled-components';
import breakpoint, { breakpointValues } from 'pricing-pages-ui/js/constants/Breakpoints';
export const mainBreakpoints = css(["width:100%;max-width:1130px;@media (min-width:", "px) and (max-width:", "px){max-width:1008px;}@media (min-width:", "px) and (max-width:", "px){max-width:776px;}"], breakpointValues.sdMac, breakpointValues.sd - 1, breakpointValues.tablet, breakpointValues.sdMac - 1);
const ProductInfoContainer = styled.main.attrs({
  role: 'main'
}).withConfig({
  displayName: "ProductInfoContainer",
  componentId: "sc-11dizue-0"
})(["display:flex;flex-direction:column;align-items:center;margin:0 18px;", " @media (min-width:", "px) and (max-width:", "px){max-width:650px;margin:0 10px;}", ";"], mainBreakpoints, breakpointValues.tabletPortrait, breakpointValues.tablet - 1, breakpoint.tabletPortrait(_t || (_t = _`
    padding-top: 20px;
    margin: 0 auto;
  `)));
export default ProductInfoContainer;